import * as React from 'react'
import {NavLink} from 'react-router-dom'

import styles from './styles.module.scss'

type Breadcrumb = {
  href: string
  label: string
}

interface Props {
  breadcrumbs: Breadcrumb[]
}

export const Breadcrumbs: React.FC<Props> = ({breadcrumbs}) => {
  return (
    <nav className={styles.container} aria-label="Breadcrumb">
      <ol>
        {breadcrumbs.map((crumb) => (
          <li key={crumb.label}>
            <NavLink to={crumb.href} exact>
              {crumb.label}
            </NavLink>
          </li>
        ))}
      </ol>
    </nav>
  )
}
